// Argomenti delle richieste di supporto (allineato a backend/src/modules/tickets/tickets.argomenti.ts)
export const ARGOMENTI_TICKET = [
  { chiave: 'CORSI',   label: 'Corsi' },
  { chiave: 'FIPAV',   label: 'Tornei FIPAV' },
  { chiave: 'ORDINI',  label: 'Ordini e merch' },
  { chiave: 'CAMPI',   label: 'Affitto campi' },
  { chiave: 'ACCOUNT', label: 'Account e accesso' },
  { chiave: 'DINK',    label: 'Dink' },
  { chiave: 'ALTRO',   label: 'Altro' },
];
export const etichettaArgomento = (k) => ARGOMENTI_TICKET.find(a => a.chiave === k)?.label || k;
// 21/10 titolare: per l'app Dink (registrazione, documenti) risponde direttamente l'assistenza Dink
export const EMAIL_DINK = 'help@dink.social';
